import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EmployeeAssesment } from 'src/app/shared/models/appraisal';
import { Message } from 'src/app/shared/models/domain';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-approval-comment',
  templateUrl: './approval-comment.component.html',
  styleUrls: ['./approval-comment.component.scss']
})
export class ApprovalCommentComponent implements OnInit {
  @Output() onCommentSubmit = new EventEmitter<Message>();
  @Input() employeeAssesment: EmployeeAssesment = {} as EmployeeAssesment;
  @Input() isActive: boolean;
  @Output() emitWizardIndex = new EventEmitter<number>();
  constructor(
    private appraisalService: ApparaisalService,
    private toastr: ToastrService,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
  }
 

  public upsertComment() {
    if (this.isActive) {
      return;
    }
    if (this.employeeAssesment.loneComments) {
      this.employeeAssesment.status = "LONE_COMPLETED";
      this.appraisalService.updateApprovalForm(this.employeeAssesment.id, this.employeeAssesment).subscribe({
        next: (response: Message) => {
          // this.onCommentSubmit.emit(response);
          if (!response.failed) {
            this.emitWizardIndex.emit(6);
            this.commonService.setToastr(200, "Comments saved Successfully");
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error?.error?.error || error.error);
        }
      });
    }
  }
}
